<template>
  <v-container grid-list-md fluid>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      v-if="userCan('view_all_branches_report')"
      class="white border justify-center align-center py-3"
    >
      <v-autocomplete
        outline
        singleLine
        hideDetails
        autocomplete
        class="mx-4"
        item-value="id"
        item-text="name"
        @change="initData"
        v-model="branch_id"
        :disabled="loading"
        :items="branch_filters"
        style="max-width: 380px"
        :placeholder="$t('branch')"
      />
      <v-spacer />
    </v-layout>
    <accounts-bar
      :exchanges="exchanges"
      :accounts_bar="accounts_bar"
      :opening_accounts_bar="opening_accounts_bar"
    />

    <v-expansion-panel right class="flex xs12 elevation-0 mb-3 shadow" v-if="userCan('view_chart')">
      <v-expansion-panel-content>
        <div slot="header" class="lr--text font-weight-bold">
          <strong>{{ $t("organization_chart") }}</strong>
        </div>
        <on-board
          :onboards="onboards"
          :branch-name="filteredBranch.name"
        />
        <!-- <v-img :src="filteredBranch.image" /> -->
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white shadow justify-center align-center pa-2"
    >
      <v-date
        :hideDetails="true"
        :has-icon="true"
        @input="initData"
        :singleLine="true"
        :clearable="false"
        format="YYYY-MM-DD"
        v-model="start_date"
        input_id="start_date"
        value-type="YYYY-MM-DD"
        :placeholder="$t('date')"
        class="mx-2 flex xs12 md2 hide-details"
      />

      <v-date
        :hideDetails="true"
        @input="initData"
        :clearable="false"
        v-model="end_date"
        :singleLine="true"
        input_id="end_date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        :placeholder="$t('date')"
        class="mx-2 flex xs12 md2 hide-details"
      />
      <!-- style="max-width:250px;" -->
      <v-spacer />
      <v-flex xs12 md4 class="di-flex justify-center align-center">
        <v-text-field
          outline
          hide-details
          class="rounded"
          v-model="search"
          :title="$t('search')"
          :placeholder="$t('search')"
          prepend-inner-icon="search"
        />
        <v-btn
          icon
          flat
          medium
          class="mx-0"
          @click="initData"
          :loading="loading"
          :title="$t('refresh')"
          color="grey darken-2"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn
          icon
          flat
          @click="printTable"
          :title="$t('print')"
          color="grey darken-2"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <credits
          class="mt-3"
          @saved="initData"
          :external-search="search"
          v-if="userCan('all_credits')"
          v-bind="{
            initList: false,
            dashboardView: true,
            credits: credits,
            st_date: start_date,
            en_date: end_date,
          }"
        />

        <debits
          class="mt-3"
          @saved="initData"
          :external-search="search"
          v-if="userCan('all_debits')"
          v-bind="{
            initList: false,
            dashboardView: true,
            debits: debits,
            st_date: start_date,
            en_date: end_date,
          }"
        />

        <exchanges
          ref="exchangeRef"
          class="mt-3"
          @saved="initData"
          :external-search="search"
          v-if="userCan('all_exchanges')"
          v-bind="{
            initList: false,
            en_date: end_date,
            st_date: start_date,
            dashboardView: true,
            exchanges: exchanges,
          }"
        />
        <a2a-transfers
          type="a2a"
          class="mt-3"
          @saved="initData"
          :external-search="search"
          label="a2a_transfers"
          v-if="userCan('all_a2a_transfers')"
          v-bind="{
            initList: false,
            dashboardView: true,
            transfers: a2a_transfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
        <send-transfers
          type="send"
          class="mt-3"
          @saved="initData"
          :external-search="search"
          label="send_transfers"
          v-if="userCan('all_send_transfers')"
          v-bind="{
            initList: false,
            dashboardView: true,
            transfers: send_transfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
        <receive-transfers
          class="mt-3"
          type="receive"
          @saved="initData"
          :external-search="search"
          label="received_transfers"
          v-if="userCan('all_receive_transfers')"
          v-bind="{
            initList: false,
            dashboardView: true,
            transfers: received_transfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import onBoard from "./onBoard";
import accountsBar from "./accountsBar2";
import debits from "@/views/roznamcha/tabs/debits";
import credits from "@/views/roznamcha/tabs/credits";
import exchanges from "@/views/roznamcha/tabs/exchanges";
import a2aTransfers from "@/views/roznamcha/tabs/a2aTransfers";
import sendTransfers from "@/views/roznamcha/tabs/sendTransfers";
import receiveTransfers from "@/views/roznamcha/tabs/receiveTransfers";

export default {
  name: "dashboard",
  components: {
    debits,
    credits,
    onBoard,
    exchanges,
    accountsBar,
    a2aTransfers,
    sendTransfers,
    receiveTransfers,
  },

  data: () => ({
    onboards: [],
    debits: [],
    credits: [],
    agencies: [],
    expenses: [],
    exchanges: [],
    branch_id: "",
    accounts_bar: [],
    a2a_transfers: [],
    send_transfers: [],
    branch_filters: [],
    received_transfers: [],
    opening_accounts_bar: [],
    search: null,
    loading: false,
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: new Date().toLocaleDateString("en-ca"),
  }),
  computed: {
    co_credits: (vm) => vm.getFilteredItem(vm.credits, "number"),
    co_debits: (vm) => vm.getFilteredItem(vm.debits, "number"),
    co_exchanges: (vm) => vm.getFilteredItem(vm.exchanges, "id"),
    co_a2a_transfers: (vm) => vm.getFilteredItem(vm.a2a_transfers, "number"),
    co_send_transfers: (vm) => vm.getFilteredItem(vm.send_transfers, "number"),
    co_received_transfers: (vm) =>
      vm.getFilteredItem(vm.received_transfers, "number"),
    filteredBranch: (vm) =>
      vm.branch_filters.find((x) => x.id == vm.branch_id) || {},
  },
  methods: {
    getFilteredItem(items, key) {
      if (this.search) {
        return items.filter((item) => {
          return ("" + item[key])
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
      return items;
    },
    initData() {
      this.loading = true;

      this.axios
        .get(
          `reports?start_date=${this.start_date}&end_date=${this.end_date}&branch_id=${this.branch_id}`
        )
        .then((resp) => {
          this.$refs.exchangeRef.initData();
          let all_transfers = resp.data.transfers;
          this.accounts_bar = resp.data.accounts_bar;
          this.opening_accounts_bar = resp.data.opening_accounts_bar;
          this.onboards = resp.data.onboards;
          this.debits = resp.data.debits;
          this.credits = resp.data.credits;
          this.agencies = resp.data.agencies;
          this.expenses = resp.data.expenses;
          this.exchanges = resp.data.exchanges;
          this.send_transfers = all_transfers.filter((x) => x.type == "send");
          this.a2a_transfers = resp.data.transfers.filter(
            (x) => x.type == "a2a"
          );
          this.received_transfers = all_transfers.filter(
            (x) => x.type == "receive"
          );
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    getBranches() {
      this.axios.get("branches").then((res) => {
        this.branch_filters = res.data;
      });
    },
    printTable() {
      const {
        accounts_bar,
        debits,
        credits,
        agencies,
        expenses,
        exchanges,
        a2a_transfers,
        send_transfers,
        received_transfers,
      } = this;

      let data = {
        headers: [
          { text: this.$t("customer"), value: "name" },
          { text: this.$t("phones"), value: "pretty_phone" },
          { text: this.$t("description"), value: "address" },
        ],
        items: {
          debits,
          credits,
          agencies,
          expenses,
          exchanges,
          a2a_transfers,
          send_transfers,
          received_transfers,
        },
        landscape: true,
        branch_name: this.filteredBranch.name,
        title: `${this.$t("daily_transactions")}  ${this.$t("from")} (${
          this.start_date
        } ${this.persianDateFilter(this.start_date, true)}) ${this.$t("to")} (${
          this.end_date
        } ${this.persianDateFilter(this.end_date, true)})`,
      };

      this.$store.commit("ReportsModule/setDailyReport", data);
      this.$router.push("/print/daily-transactions");
    },
    rateUpdated() {
      this.initData();
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.getters["AuthModule/isAuthenticated"])
        next({ path: "/auth/login" });

      let hasAccess = vm.userCan("view_dashbaord");

      if (!hasAccess) {
        let first_route = vm.$store.getters.getSidebarLinks[0];
        if (first_route.children) {
          first_route = first_route.children[0];
        }
        // vm.$store.getters.getSidebarLinks.forEach((item) => {
        //   if (item.children) first_route = item.children[0];
        //   else first_route = item;
        // });
        next(first_route);
      }
    });
  },
  created() {
    this.branch_id = this.userBranch.id;
    this.initData();
    this.getBranches();
  },
};
</script>